import { render, staticRenderFns } from "./GStarHalf.vue?vue&type=template&id=1dec9cee&"
import script from "./GStarHalf.vue?vue&type=script&lang=js&"
export * from "./GStarHalf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports